import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { FileText, Lock } from "lucide-react";
import { api } from "@/lib/api";
import { levelStyle } from "@/lib/constants";

const TEACHER_IMG = "https://static.prod-images.emergentagent.com/jobs/1304f033-c917-4974-91b0-9d4153e7c191/images/a2f9b15373644409a2436930ae1cf663989f7008b99563a556fa7a5dd5449404.jpeg";

export default function Teachers() {
  const [fiches, setFiches] = useState([]);

  useEffect(() => { api.get("/fiches/public").then((r) => setFiches(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <section className="bg-gradient-to-b from-emerald-50 to-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-600">Espace enseignants</span>
            <h1 className="font-heading font-black text-4xl sm:text-5xl lg:text-6xl text-slate-900 mt-2">
              Le programme en un coup d'œil
            </h1>
            <p className="mt-6 text-lg text-slate-600 leading-relaxed">
              Découvrez les 16 ateliers du parcours, de la 3<sup>e</sup> à la 6<sup>e</sup> primaire.
              Les fiches de mission détaillées sont mises à disposition des écoles après validation de leur réservation.
            </p>
          </div>
          <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} className="rounded-[2rem] overflow-hidden shadow-2xl shadow-emerald-500/20 rotate-2">
            <img src={TEACHER_IMG} alt="Classe" className="w-full h-[360px] object-cover" />
          </motion.div>
        </div>
      </section>

      {/* Liste des ateliers (non cliquable) */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <h2 className="font-heading font-black text-3xl text-slate-900 mb-2 flex items-center gap-2" data-testid="fiches-title">
          <Lock className="w-6 h-6 text-slate-400" /> Les fiches de mission détaillées
        </h2>
        <div className="grid sm:grid-cols-2 gap-4 mt-6" data-testid="fiches-list">
          {fiches.map((f) => {
            const s = levelStyle(f.level);
            return (
              <div key={f.slug} className="flex items-start gap-4 bg-white rounded-2xl border border-slate-100 shadow-sm p-5" data-testid={`fiche-item-${f.slug}`}>
                <span className="grid place-items-center w-12 h-12 rounded-xl bg-slate-100 text-slate-500 shrink-0">
                  <FileText className="w-6 h-6" />
                </span>
                <div className="min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <p className="font-heading font-bold text-slate-900">{f.title}</p>
                    <span className={`inline-block text-xs font-bold px-2 py-0.5 rounded-full ${s.bg} ${s.text}`}>{s.label}</span>
                  </div>
                  {f.mission && <p className="text-sm text-slate-500 mt-1.5 leading-relaxed">{f.mission}</p>}
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
}
